import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=98ecf2a6&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=js&"
export * from "./TabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=98ecf2a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ecf2a6",
  null
  
)

export default component.exports